import React from 'react'

import { getBookmarkedMatchesUrl } from '../../../api'
import Collection from './Collections'

const Engagements = () => <Collection getMatchesUrl={getBookmarkedMatchesUrl} emptyPlaceholder="You have not yet engaged with any startups, get interacting!" />
export default Engagements
